import { render, staticRenderFns } from "./AdminUsersRoute.vue?vue&type=template&id=251abec8"
import script from "./AdminUsersRoute.vue?vue&type=script&lang=js"
export * from "./AdminUsersRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports